import {
  components,
  IndicatorContainerProps,
  GroupTypeBase,
} from 'react-select';
import inputX from 'common/dist/assets/input-x.svg';

import { Option } from './Type';
import styles from './index.module.css';

const IndicatorsContainer = (
  props: IndicatorContainerProps<Option, false, GroupTypeBase<Option>>,
) => {
  return (
    <components.IndicatorsContainer {...props}>
      <img
        className={styles.Icon}
        onClick={props.clearValue}
        alt="clear"
        src={inputX}
      />
    </components.IndicatorsContainer>
  );
};

export default IndicatorsContainer;
